<!-- Modern Profile Page Design -->
<div class="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50">
  
  <!-- Profile Header Section -->
  <div class="bg-white shadow-lg border-b border-gray-200">
    <div class="max-w-7xl mx-auto px-6 py-8">
      <div class="flex flex-col lg:flex-row items-start lg:items-center gap-8">
        
        <!-- Profile Avatar -->
        <div class="flex-shrink-0">
          <div class="relative">
            <img
              class="h-32 w-32 rounded-2xl object-cover border-4 border-white shadow-xl"
              src="{{ imageUrl ? imageUrl : '../../../../../assets/image/defultprofile.jpeg' }}"
              alt="Profile"
            />
            <div class="absolute -bottom-2 -right-2">
              <div class="bg-green-500 rounded-full p-2 shadow-lg">
                <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>

        <!-- Profile Information -->
        <div class="flex-1 min-w-0">
          <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
            <div>
              <h1 class="text-3xl font-bold text-gray-900 mb-2">
                {{ profileData?.profile_name || profileData?.full_name || profileData?.org_name || profileData?.branch_name || 'Profile Name' }}
              </h1>
              <p class="text-lg text-gray-600 mb-4">
                {{ profileData?.domain || profileData?.designation || 'Organization Domain' }}
              </p>
              
              <!-- Quick Stats -->
              <div class="flex flex-wrap gap-6">
                <div class="flex items-center gap-2">
                  <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span class="text-sm font-medium text-gray-700">{{ profileData?.status || profileData?.isactive ? 'Active' : 'Inactive' }}</span>
                </div>
                <div class="flex items-center gap-2">
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"></path>
                  </svg>
                  <span class="text-sm text-gray-600">{{ profileData?.primary_contact_email || profileData?.contact_email || profileData?.email_id || 'email@example.com' }}</span>
                </div>
                <div class="flex items-center gap-2" *ngIf="profileData?.company_code || profileData?.employee_code">
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  <span class="text-sm text-gray-600">
                    {{ profileData?.company_code ? 'Company Code: ' + profileData.company_code : '' }}
                    {{ profileData?.employee_code ? 'Employee Code: ' + profileData.employee_code : '' }}
                    {{ !profileData?.company_code && !profileData?.employee_code ? 'N/A' : '' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation and Content Section -->
  <div class="max-w-7xl mx-auto px-6 py-8">
    <div class="flex flex-col lg:flex-row gap-8">
      
      <!-- Navigation Sidebar -->
      <div class="lg:w-80 flex-shrink-0">
        <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          <div class="p-6 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-900">Profile Settings</h2>
            <p class="text-sm text-gray-600 mt-1">Manage your account and preferences</p>
          </div>
          
          <nav class="p-4">
            <ul class="space-y-2">
              <li *ngFor="let item of filteredSideMenu; let i = index">
                <a
                  [routerLink]="item.route"
                  routerLinkActive="bg-blue-50 text-blue-700 border-blue-200"
                  class="flex items-center justify-between px-4 py-3 rounded-xl text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-all duration-200 border border-transparent"
                  [queryParams]="item.queryParams"
                >
                  <div class="flex items-center gap-3">
                    <div class="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center">
                      <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path *ngIf="item.name === 'Personal Details'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                        <path *ngIf="item.name === 'Notification Settings'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-5 5v-5zM4.19 4.19A2 2 0 004 6v10a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-1.81 1.19z"></path>
                        <path *ngIf="item.name === 'Password Manager'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
                        <path *ngIf="item.name === 'Bank Details'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                        <path *ngIf="item.name === 'KYC Manager'" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                      </svg>
                    </div>
                    <span>{{ item.name }}</span>
                  </div>
                  <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <!-- Quick Stats Card -->
        <div class="mt-6 bg-white rounded-2xl shadow-lg border border-gray-200 p-6 hidden">
          <h3 class="text-lg font-semibold text-gray-900 mb-4">Account Status</h3>
          <div class="space-y-4">
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-600">Profile Completion</span>
              <span class="text-sm font-medium text-green-600">85%</span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-2">
              <div class="bg-green-500 h-2 rounded-full" style="width: 85%"></div>
            </div>
            <div class="flex items-center justify-between">
              <span class="text-sm text-gray-600">Last Updated</span>
                             <span class="text-sm font-medium text-gray-900">{{ profileData?.updated_at ? (profileData.updated_at | date:'short') : 'Recently' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="flex-1">
        <div class="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden">
          <div class="p-6 border-b border-gray-200">
            <div class="flex items-center justify-between">
              <div>
                <h2 class="text-xl font-semibold text-gray-900">Profile Information</h2>
                <p class="text-sm text-gray-600 mt-1">View and manage your profile details</p>
              </div>
              <div class="flex items-center gap-2">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                  <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
                  </svg>
                  Verified
                </span>
              </div>
            </div>
          </div>
          
          <div class="p-6">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
